interface CounterProps {
  value: string;
  valuePercentage: number;
}

export function Counter({ value, valuePercentage }: CounterProps) {
  const percentage = Math.min(Math.max(valuePercentage, 0), 100);

  return (
    <section className="flex justify-center">
      <div className="relative size-32">
        <div className="absolute inset-0 rounded-full border-[0.6rem] border-muted" />

        <div
          className="absolute inset-0 rounded-full border-[0.6rem] border-primary"
          style={{
            clipPath: 'inset(0 0 0 0)',
            maskImage: `conic-gradient(blue ${percentage}%, transparent ${percentage}%)`,
            WebkitMaskImage: `conic-gradient(blue ${percentage}%, transparent ${percentage}%)`,
          }}
        />

        <span className="flex h-full items-center justify-center text-4xl font-semibold tabular-nums">
          {value}
        </span>
      </div>
    </section>
  );
}
